import { TrendingDown } from "lucide-react";
import { SectionHeading } from "@/components/landing/Reveal";
import { IMAGES } from "@/lib/site";

export const Transformations = () => {
  const list = IMAGES.transformations;
  const items = [...list, ...list];
  return (
    <section id="results" data-testid="transformations-section" className="py-24 md:py-32 bg-slate-950 scroll-mt-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <SectionHeading label="Real people, real results" title="10,000+ transformations and counting" sub="Real before-and-after photos from members — busy parents, desk workers, and self-described lazy people who pressed play." />
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-slate-950 to-transparent z-10" aria-hidden="true" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 bg-gradient-to-l from-slate-950 to-transparent z-10" aria-hidden="true" />
        <div className="flex w-max gap-8 animate-marquee hover:[animation-play-state:paused] px-4">
          {items.map((t, i) => (
            <div key={i} {...(i < list.length ? { "data-testid": `transformation-card-${i}` } : {})}
              className="group relative w-72 sm:w-80 shrink-0 rounded-[2rem] overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-[0_24px_48px_rgb(0,0,0,0.14)]">
              <img src={t.img} alt="Real member before and after transformation" className="w-full aspect-[3/4] object-cover object-top transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-900/85 via-slate-900/30 to-transparent p-6 pt-16">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-blue-600 text-white text-sm font-bold px-4 py-1.5 mb-2.5"><TrendingDown size={15} /> {t.result}</span>
                <p className="text-white font-display font-bold text-lg">{t.name}</p>
                <p className="text-slate-300 text-sm">Real member photo</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <p className="mt-10 text-center text-xs text-slate-400">Results vary. Members shown followed the full program including the nutrition guide.</p>
      </div>
    </section>
  );
};
